// ============================================
// FIREBASE CONFIGURATION FOR VITE
// ============================================

import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore, serverTimestamp as firestoreServerTimestamp } from 'firebase/firestore';

// Firebase configuration using Vite environment variables.
// Fallbacks are the shared principiantes-web-app project (same one every
// church app uses — safe to be public for Firebase web apps); the old
// shalom-church-website fallback pointed at a project that no longer exists.
const firebaseConfig = {
    apiKey: import.meta.env.VITE_FIREBASE_API_KEY || "AIzaSyAbMDHPEMR5chVRbBQwznR4avjqeiAWB4I",
    authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN || "principiantes-web-app.firebaseapp.com",
    projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID || "principiantes-web-app",
    storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET || "principiantes-web-app.appspot.com",
    messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID || "1009932777367",
    appId: import.meta.env.VITE_FIREBASE_APP_ID || "1:1009932777367:web:9be459abf375dfb825b6d2"
};

// Initialize Firebase
let app;
let auth;
let db;

try {
    app = initializeApp(firebaseConfig);
    console.log('✅ Firebase app initialized successfully');
    console.log('📋 Firebase config:', {
        apiKey: firebaseConfig.apiKey,
        authDomain: firebaseConfig.authDomain,
        projectId: firebaseConfig.projectId
    });
    console.log('🌐 Current location:', {
        origin: window.location.origin,
        hostname: window.location.hostname,
        href: window.location.href
    });
} catch (error) {
    console.error('❌ Firebase app initialization failed:', error);
    throw error;
}

// Initialize Firebase services
try {
    auth = getAuth(app);
    console.log('✅ Firebase Auth initialized successfully');
    console.log('🔑 Auth instance:', auth ? 'Created' : 'Failed');
} catch (error) {
    console.error('❌ Firebase Auth initialization failed:', error);
    throw error;
}

try {
    db = getFirestore(app);
    console.log('✅ Firestore initialized successfully');
} catch (error) {
    console.error('❌ Firestore initialization failed:', error);
    throw error;
}

// Export Firebase services
export { auth, db };

// Export serverTimestamp as a function
export const serverTimestamp = () => firestoreServerTimestamp();

// Log final initialization status
console.log('🔥 Firebase fully initialized for Vite');
